const Joi = require('joi')
const fields = require('./fields')

const walletAuthSchema = Joi.object({
    walletAddress: fields.walletAddressField.required(),
    signature: fields.signatureField.required(),
    cAppAuthRequest: fields.objectIdField.optional().label('Creator App Auth Request'),
});

module.exports = walletAuthSchema;